import { fireLinkTag } from './tagManager';

export const tagAccountDrawerOpen = (actionLocation = '') => {
  const payload = {
    event_name: 'account drawer open',
    link_name: 'account drawer open',
  };

  if (actionLocation) {
    payload.action_location = actionLocation;
  }

  fireLinkTag(payload);
};

export const tagAccountDrawerClose = () => {
  fireLinkTag({
    event_name: 'account drawer close',
    link_name: 'account drawer close',
  });
};
